import {
    SAVE_SELFIE,
    RESET_SELFIE
} from './actions';

export const initialState = {
    selfie: '',
};

const selfieReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_SELFIE:
            return {
                ...state,
                selfie: action.selfie
            }
        case RESET_SELFIE:
            return {
                ...state,
                ...initialState
            }
        default: return state
    }
}

export default selfieReducer;